// src/components/InterpretationTypesSelector.jsx
import React from "react";
import { TextField, Button, MenuItem, Chip, Typography } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

export default function InterpretationTypesSelector({
  interpretationTypeInput,
  customInterpretationType,
  selectedInterpretationTypes,
  INTERPRETATION_TYPES,
  handleChange,
  handleAddInterpretationType,
  handleRemoveInterpretationType,
}) {
  return (
    <>
      <Typography className="pt-4 font-medium text-purple-800">
        Tipos de interpretación
      </Typography>
      <TextField
        fullWidth
        label="Selecciona tipo de interpretación"
        select
        name="interpretationTypeInput"
        value={interpretationTypeInput}
        onChange={handleChange}
      >
        {INTERPRETATION_TYPES.map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </TextField>

      {interpretationTypeInput === "Otro" && (
        <TextField
          fullWidth
          label="Especifica el tipo"
          name="customInterpretationType"
          value={customInterpretationType}
          onChange={handleChange}
        />
      )}

      <Button
        onClick={handleAddInterpretationType}
        variant="contained"
        startIcon={<AddCircleOutline />}
        className="mt-2 bg-purple-600 hover:bg-purple-700 text-white"
      >
        Añadir tipo
      </Button>

      <div className="flex flex-wrap gap-2 pt-2">
        {selectedInterpretationTypes.map((type) => (
          <div key={type}>
            <Chip
              label={type}
              onDelete={() => handleRemoveInterpretationType(type)}
              color="secondary"
              className="shadow-lg hover:scale-105 transition-transform"
            />
          </div>
        ))}
      </div>
    </>
  );
}
